import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { useSidebarCollapse } from '../../../../contexts/SidebarCollapseContext'
import DraftProvider from './../../../../contexts/DraftContext'
import DraftSidebar from './DraftProcessParts/DraftSidebar'
import DraftReviewWindow from './DraftProcessParts/DraftReviewWindow'
import EmptyReviewWindow from './DraftProcessParts/EmptyReviewWindow'
import { useParams } from 'react-router-dom'
import { CampaignContext } from './../../../../contexts/CampaignContext'
import MustSelectScenarioModal from './DraftProcessParts/MustSelectScenarioModal'

export default observer(function DraftProcess() {
  const { action_id }  = useParams()
  const { selectedScenario, campaignScenarios, isLoading } = useContext(CampaignContext)
  const { isCollapsed } = useSidebarCollapse()

  return (
    <div className={`fixed top-[52px] ${isCollapsed ? 'left-[128px]' : 'left-[222px]'} w-full h-full bg-rb-grey dark:bg-rb-dark-mode-background -z-10 transition-all duration-300`}>
      <DraftProvider selectedScenario={selectedScenario}>
        <DraftSidebar />
        { action_id ? (<DraftReviewWindow />) : (<EmptyReviewWindow />)}
      </DraftProvider>
      {!isLoading && !selectedScenario && campaignScenarios.length > 0 && <MustSelectScenarioModal />}
    </div>
  )
})
